// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__12RwB","errorLogs":"EditorFooter_errorLogs__t-FvZ"};